import appconfig from '@/utils/appConfig';
import clsx from 'clsx';
import { PiLightningLight } from 'react-icons/pi';

interface IconFeatureCardProps {
    title: string;
    copy: string;
}

const containerClasses = clsx(
    'relative',
    'mx-auto',
    'w-full',
    'rounded-lg',
    'bg-gradient-to-tr',
    appconfig.colors.coloredSectionFrom,
    'to-black',
    'p-1',
    'shadow-lg',
    'pb-8',
    'mt-4',
    'md:my-8'
);

const IconFeatureCard = ({ title, copy }: IconFeatureCardProps) => {
    return (
        <div className={containerClasses}>
            <div className="bg-white p-7 rounded-md relative">
                <div className="flex flex-row">
                    <h1 className="font-bold text-3xl mb-4 mt-0 w-full">
                        {title}
                    </h1>
                </div>
                <p className="mb-14">{copy}</p>
                <PiLightningLight
                    size={50}
                    color="#A3C159"
                    className="absolute bottom-4 left-2"
                />
            </div>
        </div>
    );
};

export default IconFeatureCard;
